<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  isMain: { type: Boolean, default: false },
  textOnly: { type: Boolean, default: false },
});

const { t } = useI18n({ useScope: 'global' });

const main = computed(() => t('modules.accounts.typeTag.main'));
const sub = computed(() => t('modules.accounts.typeTag.sub'));

defineExpose({
  props,
  main,
  sub,
});
</script>

<template>
  <div :class="['account-tag', isMain ? 'account-tag--main' : 'account-tag--sub', { 'account-tag--text-only': textOnly }]">
    {{ isMain ? main : sub }}
  </div>
</template>

<style lang="scss">
.account-tag {
  --account-tag-color: rgb(var(--v-theme-primary));

  $account-tag-border-radius: 40px;

  position: relative;
  display: inline-block;
  padding: 2px 8px;
  border-radius: $account-tag-border-radius;
  color: var(--account-tag-color);
  font-size: var(--font-size-sm);

  &::before {
    position: absolute;
    border-radius: $account-tag-border-radius;
    background-color: var(--account-tag-color);
    content: '';
    inset: 0;
    opacity: 0.2;
  }
}

.account-tag--sub {
  --account-tag-color: rgb(var(--v-theme-primary));
}

.account-tag--text-only {
  padding: 0;
  border: 0;
  background-color: transparent;
}
</style>
